import React, { FC } from "react";
import { Entry } from "contentful";

interface RawHTMLProps extends Entry {
  id: string;
  fields: {
    content: string;
  }
}

const RawHTML: FC<RawHTMLProps> = ({ id, fields: { content } }) => {
  return <div dangerouslySetInnerHTML={{__html: content}} data-component-id={id} />
}

export default RawHTML;